export default __webpack_public_path__ + "static/media/partners-logo-chungnam-w@2x.682c6931.webp";